import React, { useState } from 'react';
import ImageLightbox from './ImageLightbox';
import img1 from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.48 PM(1).png';
import img2 from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM (1)(1).jpeg';
import img3 from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM (2)(1).png';
import img4 from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.49 PM(1).png';
import img5 from '../assets/hero banner/2/WhatsApp Image 2026-04-09 at 5.23.50 PM(1).png';
import img6 from '../assets/WhatsApp Image 2026-04-07 at 10.27.07 AM.jpeg';

/** Featured Projects — fixed photos from `src/assets` (swap imports to change). */
const FEATURED_PROJECTS = [
  { id: 'fp-1', title: 'Modern Living Space', category: 'Living', image: img1 },
  { id: 'fp-2', title: 'Serene Bedroom Retreat', category: 'Bedroom', image: img2 },
  { id: 'fp-3', title: 'Designer Kitchen', category: 'Kitchen', image: img3 },
  { id: 'fp-4', title: 'Executive Office', category: 'Office', image: img4 },
  { id: 'fp-5', title: 'Signature Interior', category: 'Residential', image: img5 },
  { id: 'fp-6', title: 'Luxury Living', category: 'Living', image: img6 },
];

const HomeGallerySection = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-8 md:px-16" style={{backgroundColor: '#F5EFE6'}}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6" style={{color: '#3E3E3E'}}>
            Featured Projects
          </h2>
          <p className="text-base sm:text-lg md:text-xl max-w-2xl sm:max-w-3xl mx-auto" style={{color: '#7A7A7A'}}>
            Discover our latest interior design transformations and creative solutions
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10">
          {FEATURED_PROJECTS.map((project) => (
            <div key={project.id} className="group relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300">
              <div
                role="button"
                tabIndex={0}
                className="aspect-[4/3] overflow-hidden cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C8A96A] focus-visible:ring-offset-2 focus-visible:ring-offset-[#F5EFE6]"
                onClick={() =>
                  setLightbox({
                    src: project.image,
                    alt: `${project.title} — ${project.category}`,
                  })
                }
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setLightbox({
                      src: project.image,
                      alt: `${project.title} — ${project.category}`,
                    });
                  }
                }}
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-contain object-center transition-transform duration-500 group-hover:scale-105 pointer-events-none"
                />
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-lg sm:text-xl font-bold mb-2">{project.title}</h3>
                  <p className="text-sm opacity-90">{project.category}</p>
                </div>
              </div>

              <div className="absolute top-4 left-4 pointer-events-none">
                <span
                  className="px-3 py-1 rounded-full text-xs sm:text-sm font-medium"
                  style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
                >
                  {project.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/gallery"
            className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 rounded-full font-medium transition-all duration-300 text-sm sm:text-base hover:scale-105"
            style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
          >
            <span>View Full Gallery</span>
            <span className="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>

        <ImageLightbox
          isOpen={!!lightbox}
          src={lightbox?.src ?? null}
          alt={lightbox?.alt ?? ''}
          onClose={() => setLightbox(null)}
        />
      </div>
    </section>
  );
};

export default HomeGallerySection;
